import { useMutation } from '@apollo/client'
import {
  deleteDraftTreatment,
  deleteDraftTreatmentVariables,
} from '../../../../../../models/graphqlTypes'
import { DELETE_DRAFT_TREATMENT } from '../../../../../../operations'
import { useTranslation, useUserType } from '../../../../../../common/hooks'
import { useStoreActions } from '../../../../../../store/store.hooks'
import { useHistory, useParams } from 'react-router-dom'
import { DoctorPatientRouteParams } from '../../../../DoctorPatients/types/doctorPatients.types'

export const useDeleteDraftTreatment = () => {
  const { t } = useTranslation()
  const setToast = useStoreActions((actions) => actions.toast.setToast)

  const { patientId } = useParams<DoctorPatientRouteParams>()
  const history = useHistory()
  const userType = useUserType()

  return useMutation<deleteDraftTreatment, deleteDraftTreatmentVariables>(
    DELETE_DRAFT_TREATMENT,
    {
      onCompleted: async () => {
        setToast({
          text: t('notification:successDeleteDraftTreatment'),
          type: 'success',
        })
        history.push(`/${userType}/patients/${patientId}`)
      },
    }
  )
}
